// extracted by mini-css-extract-plugin
export default {"container":"HeaderRight_container__eJG3R","title":"HeaderRight_title__svOZU"};